import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ChartType, ChartOptions } from 'chart.js';
import { IStatistic, IStatisticParams } from '@shared-libs/interfaces';
import { StatisticScale } from '@shared-libs/enums';
import { DateHelper } from '@shared-libs/helpers';

@Component({
	selector: 'statistic-component',
	templateUrl: 'statistic.component.html',
	styleUrls: ['./statistic.component.scss'],
})
export class StatisticComponent implements OnChanges, OnInit {
	@Input() public title: string;
	@Input() public subtitle: string;
	@Input() public explanation: string;
	@Input() public chartType: ChartType;
	@Input() public options: ChartOptions;
	@Input() public canToggleLegend: boolean = false;
	@Input() public canToggleLegendItems: boolean = false;
	@Input() public dataRequest: () => Promise<IStatistic>;
	@Input() public params: IStatisticParams;
	@Input() public stateKey: string;
	@Output() public paramsChanged: EventEmitter<IStatisticParams> = new EventEmitter();

	public statistic: IStatistic;
	public isLoading: boolean;
	public isErrored: boolean;
	public isEmpty: boolean;

	public scales: Array<string> = Object.values(StatisticScale);

	constructor() {}

	public ngOnInit(): void {
		this.getData();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.dataRequest = changes.dataRequest.currentValue;
		if (!changes.dataRequest.isFirstChange()) {
			this.getData();
		}
	}

	private getData(): void {
		this.isLoading = true;
		this.dataRequest()
			.then((result) => {
				if (result.datasets && result.datasets.length === 0) {
					this.isEmpty = true;
				}
				this.statistic = result;
				this.isLoading = false;
				this.isErrored = false;
				if (!this.subtitle && result.dateRange) {
					this.subtitle = DateHelper.getDateRangeString(result.dateRange);
				}
			})
			.catch(() => {
				this.isErrored = true;
				this.isLoading = false;
			});
	}
}
